import { compose } from 'redux'

import withErrorBoundary from 'components/shared/withErrorBoundary'
import withRedux from './withRedux'
import withFormResults from 'components/shared/withFormResults'
import withMutation from './withMutation'
import withState from './withState'
import withEventHandlers from './withEventHandlers'

// presentational component
import UI from './UI'

const withNewPickupPersonForm = options => {
  const { redirect, onSuccess } = options

  const withNewPickupPersonFormFormResults = withFormResults({
    mutation: 'createPickupPerson',
    field: 'pickupPerson',
    successMessage: 'Pick-up person added',
    onSuccess,
    redirect
  })

  return compose(
    withErrorBoundary,
    withRedux,
    withNewPickupPersonFormFormResults,
    withMutation,
    withState,
    withEventHandlers
  )
}

// in account manager, redirect to account overview
export default withNewPickupPersonForm({
  redirect: '/'
})(UI)

// export HOC for registration flow
export { withNewPickupPersonForm }
